const deduplicateSlashes = url => url.replace(/\/{2,}/g, '/');

export default deduplicateSlashes;
